// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container_ocRXd,.container_ocRXd *{box-sizing:border-box;-webkit-font-smoothing:antialiased;font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.container_ocRXd{border-radius:0;background:#fff;border-bottom:1px solid rgba(0,0,0,.15)}.header_wbtce{display:flex}.closeButton_vqrUz{display:flex;align-items:center;justify-content:center;width:60px;height:60px;cursor:pointer}.closeButton_vqrUz .closeIcon_Ol\\+OC{width:14px;height:14px;color:#272525}", ""]);
// Exports
exports.locals = {
	"container": "container_ocRXd",
	"header": "header_wbtce",
	"closeButton": "closeButton_vqrUz",
	"closeIcon": "closeIcon_Ol+OC"
};
module.exports = exports;
